import axios from 'axios';

const BASE = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BASE}/api`;

// ── Global axios interceptor: inject auth token on every request ──
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('hexopdf_token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
